import { create } from "zustand"
import {
  ELanguage,
  type IToken,
 // type TSplashConfig,
  type TTokenState,
} from './store';

import {
  DEFAULT_SPLASH_VIDEO_DETAILS,
  USER_TOKEN,
} from '../appConstants/AppConstant';
import { persist, createJSONStorage } from 'zustand/middleware';
import { resetAllStores } from "../utils/ResetStoresOnLogout";
import LocalStorageWrapper from "../components/common/@database/localStorage";
import { CX_LANGUAGE, LANGUAGE, NAVIGATION_ROUTES } from "../constant"; 
// import { navigateAndReset } from '@core/RootNavigation';

const initialTokenState = {
  token: {} as IToken,
  splashConfig: DEFAULT_SPLASH_VIDEO_DETAILS,
  language: LANGUAGE as ELanguage,
  cxLanguage: CX_LANGUAGE as ELanguage,
  serialNumber: '',
  fcmToken: '',
};

export const useTokenStore = create<TTokenState>()(
  persist(
    (set) => ({
      ...initialTokenState,

      resetTokenStore: () => set((state: any) => {
        return {
          ...initialTokenState,
          serialNumber: state.serialNumber,
          language: state.language,
        };
      }),
    }),
    {
      name: USER_TOKEN,
      storage: createJSONStorage(
        () =>
          new LocalStorageWrapper(),
      ),
    },
  ),
);

export function logout() {
  console.log('[LOGOUT] Logging out user...');
  
  // Clear all stores and localStorage
  resetAllStores();
  
  // Force clear Zustand persist storage to prevent rehydration
  if (useTokenStore.persist?.clearStorage) {
    useTokenStore.persist.clearStorage();
  }
  
  // Navigate to home page (which will redirect to signup if no token)
  // Use window.location for hard redirect to ensure clean state
  setTimeout(() => {
    window.location.href = NAVIGATION_ROUTES.REFERRAL_HOME;
  }, 100);
}

export function dispatchToken(token: IToken) {
  const state = useTokenStore.getState();
  
  useTokenStore.setState({ ...state, token });
}